import { CARD_PLUS2, NOTE_REVERSED, NOTE_SKIPPED, activeCard, handCount } from '@chessbut/engine';
import type { VariantUi } from './ui.ts';

const CARDS = '/art/cards.svg';

export const wildcardUi: VariantUi = {
  heroImage: CARDS,
  peek: [{}, { image: '/art/bK.svg' }, {}, {}, { image: CARDS }, {}, {}, { image: '/art/wN.svg' }, {}],

  twist(pos, you) {
    const { card, left, note } = activeCard(pos);
    const mine = you === null || pos.turn === you;
    const who = mine ? (you === null ? (pos.turn === 0 ? 'White' : 'Black') : 'You') : 'They';
    const parts: string[] = [];
    if (note & NOTE_REVERSED) parts.push('🔄 Reverse! The armies swapped.');
    if (note & NOTE_SKIPPED) parts.push('⛔ Skip!');
    if (card === CARD_PLUS2) {
      parts.push(`🃏 +2: ${who} put${who === 'You' || who === 'They' ? '' : 's'} captured pieces back (${left} to go, ${handCount(pos, pos.turn)} waiting).`);
    } else {
      parts.push(`🃏 ${card}: ${who} ${card === 1 ? 'move once' : `make ${card} moves`}${card > 1 ? ` (${left} left)` : ''}.`);
    }
    return {
      text: parts.join(' '),
      pips: card === CARD_PLUS2 ? undefined : { on: left, total: card, title: 'Moves left this turn. Giving check ends the turn.' },
      alert: (note & NOTE_REVERSED) !== 0,
    };
  },

  eventSound(e) {
    if (e.t !== 'fx') return null;
    return e.kind === 'reverse' ? 'flip' : e.kind === 'skip' ? 'boing' : null;
  },

  moveBadge(rec) {
    if (rec.events.some((e) => e.t === 'fx' && e.kind === 'reverse')) return { icon: CARDS, title: 'Reverse: the armies swapped' };
    if (rec.events.some((e) => e.t === 'fx' && e.kind === 'skip')) return { icon: CARDS, title: 'Skip' };
    return null;
  },
};
